'use strict';

var urlCapAddressSearchline = $('#url-cap-address-searchline').val();

/**
* Searches for locality information based on the provided zip code and country.
*
* @param {number} steep - The step of the search process.
* @param {string} zipCode - The zip code to search for.
* @param {string} currentCountry - The country in which to search for the locality.
* @returns {Object} The result of the locality search, containing locality data or an error message.
*/
async function SearchLocality(steep, zipCode, currentCountry) {
    var capData = {
        currentCountry: currentCountry,
        inputOutput: zipCode,
        step: steep
    };

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: urlCapAddressSearchline,
            type: 'get',
            data: capData,
            dataType: 'json',
            success: function (data) {
                if (data.error && window.capency) {
                    window.capency.isServiceUp = false;
                } else {
                    window.capency.isServiceUp = true;
                }
                resolve(data);
            },
            error: function (err) {
                if (window.capency) {
                    window.capency.isServiceUp = false;
                }
                reject(err);
            }
        });
    });
}

/**
* Searches for street information based on the provided search data.
*
* @param {Object} dataSearchStreet - The data used to search for street information.
* @param {string} dataSearchStreet.step - The step of the search process. Defaults to 'Undefined' if not provided.
* @returns {Object} The result of the street search, which includes street information if the search is successful.
*
* @example
* const searchData = { step: 'initial', query: 'Main St' };
* const result = SearchStreet(searchData);
* console.log(result);
*/
async function SearchStreet(dataSearchStreet) {
    if (!dataSearchStreet.step) {
        dataSearchStreet.step = 'Undefined';
    }

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: urlCapAddressSearchline,
            type: 'get',
            data: dataSearchStreet,
            dataType: 'json',
            success: function (data) {
                if (data.error && window.capency) {
                    window.capency.isServiceUp = false;
                } else {
                    window.capency.isServiceUp = true;
                }
                resolve(data);
            },
            error: function (err) {
                if (window.capency) {
                    window.capency.isServiceUp = false;
                }
                reject(err);
            }
        });
    });
}

/**
* Sends an AJAX request to search for a street number and returns the result.
*
* @param {Object} dataSearchStreetNumber - The data object containing search parameters.
* @param {string} dataSearchStreetNumber.request - The type of request being made, set to 'SearchLine'.
* @param {string} dataSearchStreetNumber.step - The current step of the search, set to 'SearchStreetNumber'.
* @returns {Object} The result of the AJAX request, containing the search results.
*/
async function SearchStreetNumber(dataSearchStreetNumber) {
    dataSearchStreetNumber.request = 'SearchLine';
    dataSearchStreetNumber.step = 'SearchStreetNumber';

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: urlCapAddressSearchline,
            type: 'get',
            data: dataSearchStreetNumber,
            dataType: 'json',
            success: function (data) {
                resolve(data);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
}

/**
* Searches for a building using the provided search data and returns the result.
*
* @param {Object} dataSearchBuilding - The data required for the building search.
* @param {string} dataSearchBuilding.request - The type of request, set to 'SearchLine'.
* @param {string} dataSearchBuilding.step - The step of the search process, set to 'SearchBuilding'.
* @returns {Object} The result of the building search.
*/
async function searchBuilding(dataSearchBuilding) {
    dataSearchBuilding.request = 'SearchLine';
    dataSearchBuilding.step = 'SearchBuilding';

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: urlCapAddressSearchline,
            type: 'get',
            data: dataSearchBuilding,
            dataType: 'json',
            success: function (data) {
                resolve(data);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
}

/**
* Searches for an address by postal code using an AJAX request.
*
* @param {Object} dataSearchStreet - The data to be sent with the AJAX request, typically containing the postal code.
* @returns {Object} The result of the AJAX request, typically a JSON object containing address information.
*
* @example
* var data = { postalCode: '12345' };
* var address = searchAddressByPostalCode(data);
* console.log(address);
*
* @description
* This function performs a synchronous AJAX GET request to the `urlCapAddressSearchline` endpoint with the provided data.
* If the request is successful, it updates the `window.capency.isServiceUp` flag to `true`. If there is an error or if the
* response contains an error, it sets the `window.capency.isServiceUp` flag to `false`.
*/
async function searchAddressByPostalCode(dataSearchStreet) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: urlCapAddressSearchline,
            type: 'get',
            data: dataSearchStreet,
            dataType: 'json',
            success: function (data) {
                if (window.capency) {
                    window.capency.isServiceUp = true;
                }

                if (data.error && window.capency) {
                    window.capency.isServiceUp = false;
                }
                resolve(data);
            },
            error: function (err) {
                if (window.capency) {
                    window.capency.isServiceUp = false;
                }
                reject(err);
            }
        });
    });
}

/**
* Asynchronously validates a form by making an AJAX GET request to a specified URL with given parameters.
*
* @param {Object} params - The parameters to be sent with the AJAX request.
* @returns {Promise} A promise that resolves with the data returned from the AJAX request if successful,
*                    or rejects with an error if the request fails.
*/
async function ValidationForm(params) {
    return new Promise(function (resolve, reject) {
        $.ajax({
            url: urlCapAddressSearchline,
            type: 'get',
            data: params,
            success: function (data) {
                resolve(data);
            },
            error: function (err) {
                reject(err);
            }
        });
    });
}

module.exports = {
    SearchLocality: SearchLocality,
    SearchStreet: SearchStreet,
    SearchStreetNumber: SearchStreetNumber,
    searchBuilding: searchBuilding,
    searchAddressByPostalCode: searchAddressByPostalCode,
    ValidationForm: ValidationForm
};
